// extracted by mini-css-extract-plugin
module.exports = {"Container":"Shell_Container__2Lvok","ContainerChildren":"Shell_ContainerChildren__14BWl"};